import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbCalendar, NgbDate, NgbDateParserFormatter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { ConfirmDialogComponent } from 'app/dialogs/confirm-dialog/confirm-dialog.component';
import { CreateCertificateDialogComponent } from 'app/dialogs/create-certificate-dialog/create-certificate-dialog.component';
import { UpdateCalibrationDialogComponent } from 'app/dialogs/update-calibration-dialog/update-calibration-dialog.component';
import { CalibrationStatus } from 'app/enum/calibrationStatus';
import { CalibrationService } from 'app/services/models/calibration.service';
import { CompanyService } from 'app/services/models/company.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { title } from 'process';

@Component({
  selector: 'app-calibration-list',
  templateUrl: './calibration-list.component.html',
  styleUrls: ['./calibration-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CalibrationListComponent implements OnInit {
  public contentHeader: object;

  @BlockUI('section-block') blockUI: NgBlockUI;
  rows: any[] = [];
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption = 5;
  public searchValue = '';
  totalCount: number = 0;
  public ColumnMode = ColumnMode;
  companies: any[] = [];
  selectedCompanyId = null;
  startFilterDate?: string | null = null;
  endFilterDate?: string | null = null;
  public calibrationStatusMapping = {
    [CalibrationStatus.OnayBekliyor]: {
      text: 'Onay Bekliyor',
      style: 'badge badge-info'
    },
    [CalibrationStatus.Tamamlandı]: {
      text: 'Tamamlandı',
      style: 'badge badge-success'
    },
    [CalibrationStatus.İptalEdildi]: {
      text: 'İptal Edildi',
      style: 'badge badge-danger'
    }
  };

  selectedAkradetionOgranizationId = null;
  akradetionOrganization = [
    { id: 1, name: "Türkak" },
    { id: 2, name: "NAC" },
    { id: 3, name: "İzlenebilirik" },
    { id: 4, name: "IAS" }
  ]

  selectedStatusId: number = null
  public calibrationStatusOptions = [
    { value: CalibrationStatus.OnayBekliyor, text: 'Onay Bekliyor' },
    { value: CalibrationStatus.Tamamlandı, text: 'Tamamlandı' },
    { value: CalibrationStatus.İptalEdildi, text: 'İptal Edildi' }
  ];

  constructor(
    private calibrationService: CalibrationService,
    private modalService: NgbModal,
    private toastrSerive: ToastrService,
    private companyService: CompanyService,
    public formatter: NgbDateParserFormatter,
    private calendar: NgbCalendar,
    private datePipe: DatePipe,
  ) { }

  async onStatus(event) {
    console.log(event.target.value);
    this.selectedStatusId = event.target.value;
    await this.getAllCalibrations(this.pageBasic - 1, this.selectedSize, this.startFilterDate, this.endFilterDate, this.selectedCompanyId, this.selectedAkradetionOgranizationId, this.selectedStatusId);
  }

  async resetFilter() {
    this.startFilterDate = null;
    this.endFilterDate = null;
    this.selectedCompanyId = null;
    this.selectedAkradetionOgranizationId = null;
    this.selectedStatusId = null;
    this.fromDate = null;
    this.toDate = null
    await this.getAllCalibrations(this.pageBasic - 1, this.selectedSize, this.startFilterDate, this.endFilterDate, this.selectedCompanyId, this.selectedAkradetionOgranizationId, this.selectedStatusId);
  }

  calibrationAkradetionOrganization(number) {
    const organization = this.akradetionOrganization.find(p => p.id == number);
    return organization.name
  }

  async onAkreditonOgranzitonChange(event) {
    console.log(event.target.value);
    this.selectedAkradetionOgranizationId = event.target.value;
    await this.getAllCalibrations(this.pageBasic - 1, this.selectedSize, this.startFilterDate, this.endFilterDate, this.selectedCompanyId, this.selectedAkradetionOgranizationId, this.selectedStatusId);
  }

  updateStatus(row: any, newStatus: number) {
    const previousStatus = row.status; // Önceki durumu sakla

    row.status = +newStatus; // newStatus string gelebilir, number'a çeviriyoruz.
    // Burada API çağrısı veya diğer güncelleme işlemlerini yapabilirsiniz.
    console.log(row.status);
    const modal = this.modalService.open(ConfirmDialogComponent, {
      windowClass: 'modal modal-success'
    });
    modal.componentInstance.data = {
      title: "Kalibrasyon Onayı!",
      message: 'Kalibrasyon durumunu güncellemek istediğinizden emin misiniz?'
    };

    modal.result.then(async (result) => {
      console.log("Modal Onaylandı, Dönen Değer:", result);
      if (result === true) {
        console.log("Durum güncellendi:", row);
        const data = await this.calibrationService.updateCalibrationStatus(row.id, row.status);
        if (data.status) {
          await this.getAllCalibrations(this.pageBasic - 1, this.selectedSize, this.startFilterDate, this.endFilterDate, this.selectedCompanyId, this.selectedAkradetionOgranizationId, this.selectedStatusId);
          this.toastrSerive.success(data.message);
        } else {
          this.toastrSerive.error(data.message);
        }
      } else {
        row.status = previousStatus; // Kullanıcı iptal etti, eski durumu geri al
      }
    }).catch((dismissReason) => {
      //console.log("Modal İptal Edildi, Dönüş Nedeni:", dismissReason);
      // Kullanıcı iptal ettiyse burada işlem yapabilirsiniz.
    });
  }


  async ngOnInit() {
    this.contentHeader = {
      headerTitle: 'Kalibrasyon',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Kalibrasyon Yapılanlar',
            isLink: false,
          },
        ]
      }
    }
    await this.getAllCalibrations(this.pageBasic - 1, this.selectedSize, this.startFilterDate, this.endFilterDate, this.selectedCompanyId, this.selectedAkradetionOgranizationId, this.selectedStatusId);
    await this.getAllCompanies();
  }

  async getAllCompanies() {
    const data = await this.companyService.getAllCompany('', 0, 1000);
    console.log(data);
    this.companies = data.companies;
  }

  async getAllCalibrations(page: number, size: number, startDate, endDate, companyId, accreditationOgranization, status) {
    this.blockUI.start();
    try {
      const data = await this.calibrationService.getAllCalibrations(page, size, startDate, endDate, companyId, accreditationOgranization, status);
      console.log(data);
      this.rows = data.calibrations;
      this.totalCount = data.totalCount;
    } catch (error) {
      console.error('Error fetching currencies:', error);
    }
    this.blockUI.stop();
  }

  async onPageChange() {
    await this.getAllCalibrations(this.pageBasic - 1, this.selectedSize, this.startFilterDate, this.endFilterDate, this.selectedCompanyId, this.selectedAkradetionOgranizationId, this.selectedStatusId);
  }

  async onOptionChange() {
    this.selectedSize = Number(this.basicSelectedOption);
    await this.getAllCalibrations(this.pageBasic - 1, this.selectedSize, this.startFilterDate, this.endFilterDate, this.selectedCompanyId, this.selectedAkradetionOgranizationId, this.selectedStatusId);
  }

  async onCompanySelect(event) {
    console.log(event);
    this.selectedCompanyId = event.id;
    await this.getAllCalibrations(this.pageBasic - 1, this.selectedSize, this.startFilterDate, this.endFilterDate, this.selectedCompanyId, this.selectedAkradetionOgranizationId, this.selectedStatusId);
  }

  showUpdateCalibration(id) {
    const modal = this.modalService.open(UpdateCalibrationDialogComponent, {
      size: 'xl',
      windowClass: 'modal modal-warning'
    });
    modal.componentInstance.data = id;
  }

  showCreateCertificate(calibrationId) {
    const modal = this.modalService.open(CreateCertificateDialogComponent, {
      size: 'lg',
      windowClass: 'modal modal-success'
    });
    modal.componentInstance.data = {
      calibrationId: calibrationId,
    }
  }

  async onOptionDateChange() {
    // Tarih değiştiğinde yapılacak işlemler buraya
    await this.getAllCalibrations(this.pageBasic - 1, this.selectedSize, this.startFilterDate, this.endFilterDate, this.selectedCompanyId, this.selectedAkradetionOgranizationId, this.selectedStatusId);
  }

  public hoveredDate: NgbDate | null = null;
  public fromDate: NgbDate | null;
  public toDate: NgbDate | null;

  /**
 * Range selection Date Picker
 *
 * @param date
 */
  async onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }

    const startDateFormatted = this.formatDate2(this.fromDate);
    const endDateFormatted = this.formatDate2(this.toDate);

    console.log('Start Date:', startDateFormatted ? startDateFormatted : 'Not selected');
    console.log('End Date:', endDateFormatted ? endDateFormatted : 'Not selected');

    this.startFilterDate = (startDateFormatted).toString();
    this.endFilterDate = (endDateFormatted).toString();

    await this.getAllCalibrations(this.pageBasic - 1, this.selectedSize, this.startFilterDate, this.endFilterDate, this.selectedCompanyId, this.selectedAkradetionOgranizationId, this.selectedStatusId);
  }

  formatDate2(date: NgbDate): string | null {
    if (!date) return null;
    // Convert NgbDate to JavaScript Date object
    const jsDate = new Date(date.year, date.month - 1, date.day);
    // Format the date using DatePipe
    return this.datePipe.transform(jsDate, 'yyyy-MM-dd');
  }

  /**
   * Is Hovered
   *
   * @param date
   */
  isHovered(date: NgbDate) {
    return (this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate));
  }

  /**
   * Is Inside
   * @param date
   */
  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  /**
   *  Is Range
   *
   * @param date
   */
  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  displayDateRange(): string {
    if (this.fromDate && this.toDate) {
      return `${this.formatter.format(this.fromDate)} - ${this.formatter.format(this.toDate)}`;
    } else if (this.fromDate) {
      return this.formatter.format(this.fromDate);
    }
    return '';
  }
}